import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { recordActions } from "data/recordApi"

import Card from "ui/components/Card"
import Table from "ui/components/Table"
import Text from "ui/components/Text"

import Attribute from "../../records/components/Attribute"
import WithRecords from "data/wrappers/WithRecords"
import WithObject from "data/wrappers/WithObject"
import DeleteRecordButton from "./DeleteRecordButton"

import ObjectFieldsFilter, { processFilter } from "features/records/components/RecordFilters"

const RecordTable = props => {
    return (
        <WithObject objectId={props.objectId}>
            {({ object, primaryField }) => (
                <React.Fragment>
                    {/*<ObjectFieldsFilter
                        object={object}
                        defaultValue={props.dataFilters}
                        onChange={filters =>
                            props.onDataFiltersChange && props.onDataFiltersChange(filters)
                        }
                    />*/}
                    <WithRecords objectId={props.objectId}>
                        {({ records, onChange }) => {
                            return (
                                <Table
                                    columns={[
                                        getPrimaryColumn(primaryField),
                                        ...object.fields
                                            .filter(field => field._sid !== primaryField._sid)
                                            .map(field => mapFieldToColumn(field, onChange)),
                                        getRemoveColumn(props),
                                    ]}
                                    data={filterRecordsFromDict(
                                        processFilter(records, props.dataFilters),
                                        props.filters || {}
                                    )}
                                    defaultSorted={[props.order || {}]}
                                />
                            )
                        }}
                    </WithRecords>
                </React.Fragment>
            )}
        </WithObject>
    )
}

RecordTable.propTypes = {
    objectId: PropTypes.string,
}

const getPrimaryColumn = primaryField => {
    return {
        accessor: primaryField.api_name,
        Header: primaryField.label,
        minWidth: 150,
        Cell: cell => (
            <Link to={"/record/" + cell.original._sid}>
                <Text margin={"none"}>{cell.original[primaryField.api_name]}</Text>
            </Link>
        ),
    }
}

const getRemoveColumn = props => {
    return {
        accessor: "id",
        Header: "",
        width: 50,
        maxWidth: 50,
        Cell: cell => (
            <div className="hover" style={{ color: "#EEE", paddingTop: 10 }}>
                <DeleteRecordButton delete={() => props.recordActions.remove(cell.original._sid)} />
            </div>
        ),
    }
}

const mapFieldToColumn = (field, updateRecord) => {
    return {
        accessor: field.api_name,
        Header: field.label,
        minWidth: 150,
        Cell: cell => (
            <Attribute
                onChange={value => {
                    updateRecord(cell.original._sid, { [field.api_name]: value })
                }}
                editable
                inline
                field={field}
            >
                {cell.value}
            </Attribute>
        ),
    }
}

const filterRecordsFromDict = (records, filters) => {
    let results = records || []
    Object.keys(filters).forEach(field => {
        results = results.filter(result => result[field] === filters[field])
    })
    return results
}

function mapDispatchToProps(dispatch) {
    return {
        recordActions: bindActionCreators(recordActions, dispatch),
    }
}

export default connect(
    () => {},
    mapDispatchToProps
)(RecordTable)



// WEBPACK FOOTER //
// ./src/features/studio/components/RecordTable.js